import React from "react"

import { Team } from "entities/teams/types/Team"

import { TeamInitialsListView } from "./TeamInitialsListView"
import { useTeamInitialsList } from "./model/useTeamInitialsList"

export interface TeamInitialsListProps {
  team: Team
  shownMemberCount?: number
  ignoredUserEmails?: string | string[]
}

export const TeamInitialsList = React.memo((props: TeamInitialsListProps) => {
  return <TeamInitialsListView {...useTeamInitialsList(props)} />
})
